export default __webpack_public_path__ + "static/media/homeLinkMobile.1981de1a.svg";